export { InvestmentsServicesPartnershipPage as default } from "@nvb/ui";
